import { useContext, useState } from 'react'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Form } from '@unform/web'
import { t } from 'i18next'

import { FeedbackContext } from '~/components/feedback'
import { ButtonsCancelSave } from '~/components/Buttons'
import { addKeywordsBulkService } from '~/modules/retailMedia/services/campaign-keyword'

import PlacementSearch from '../../CampaignForm/elements/Targeting/Keywords'

type FormNewCampaignKeyWordProps = {
  campaignId: string
  callback?: (data?: unknown) => void
}

const FormNewCampaignKeyWord = ({
  campaignId,
  callback
}: FormNewCampaignKeyWordProps) => {
  const [buttonLoadingKeyword, setButtonLoadingKeyword] = useState(false)
  const [keywordsList, setKeywordsList] = useState<string[]>([])
  const { toast } = useContext(FeedbackContext)

  const QUERY_KEY = ['get-keywords', campaignId]
  const queryClient = useQueryClient()

  const addKeywordMutation = useMutation({
    mutationFn: addKeywordsBulkService,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEY
      })

      setButtonLoadingKeyword(false)

      toast.success(t('rm:campaign.form.new.keyword.success.message'))
      callback()
    },
    onError: () => {
      setButtonLoadingKeyword(false)
      toast.critical(t('rm:campaign.form.new.keyword.error.message'))
    }
  })

  const handleSubmit = async () => {
    setButtonLoadingKeyword(true)

    if (!keywordsList.length) {
      setButtonLoadingKeyword(false)
      toast.critical(t('rm:campaign.form.new.keyword.warn.empty.message'))
      return
    }
    await addKeywordMutation.mutateAsync({
      campaignId,
      keywords: keywordsList
    })
  }

  return (
    <section className="px-3 pb-3">
      <Form onSubmit={handleSubmit}>
        <PlacementSearch
          onChange={({ keywords }) => setKeywordsList(keywords)}
        />

        <hr />

        <ButtonsCancelSave
          onCancelClick={callback}
          isLoading={buttonLoadingKeyword}
        />
      </Form>
    </section>
  )
}

export default FormNewCampaignKeyWord
